import React from "react";
import { useNavigate } from "react-router-dom";

const formatNumber = (value) => {
  if (value === null || value === undefined) return "0";
  const num = Number(value);
  if (Number.isNaN(num)) return value;
  return num.toLocaleString("es-EC");
};

const accentMap = {
  blue: { bg: "#e0ecff", fg: "#1d4ed8" },
  violet: { bg: "#ebe9ff", fg: "#6d28d9" },
  green: { bg: "#e5f8f2", fg: "#0f766e" },
  amber: { bg: "#fff4e0", fg: "#c2410c" },
  aqua: { bg: "#e0f7ff", fg: "#0ea5e9" },
  coral: { bg: "#ffe7e2", fg: "#dc2626" },
};

export default function StudentsTab({ estudiantes = {} }) {
  const navigate = useNavigate();
  const kpis = estudiantes.kpis || [];
  const riesgos = estudiantes.riesgos || [];

  return (
    <>
      <div className="row g-3 admin-kpi-row">
        {kpis.map((kpi) => (
          <div className="col-12 col-sm-6 col-lg-3" key={kpi.label}>
            <div className="admin-kpi-card h-100">
              <div className="admin-kpi-body">
                <span
                  className="admin-kpi-icon"
                  style={{
                    backgroundColor: accentMap[kpi.accent]?.bg || "#e5e7eb",
                    color: accentMap[kpi.accent]?.fg || "#0f172a",
                  }}
                >
                  <i className={`bi ${kpi.icon || "bi-people-fill"} me-0`} />
                </span>
                <div className="admin-kpi-text">
                  <p className="admin-kpi-label mb-0">{kpi.label}</p>
                  <div className="admin-kpi-value">{formatNumber(kpi.value)}</div>
                  <div className="admin-kpi-helper">{kpi.helper}</div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="card admin-section-card mt-3">
        <div className="card-header bg-white border-0 d-flex justify-content-between align-items-center">
          <div>
            <h6 className="mb-0">Estudiantes en Riesgo Documental</h6>
            <small className="text-muted">Pendientes o vencidos por estudiante</small>
          </div>
          <span className="dashboard-chip">
            <i className="bi bi-exclamation-octagon me-1" />
            {riesgos.length}
          </span>
        </div>
        <div className="table-responsive">
          <table className="table align-middle mb-0">
            <thead>
              <tr>
                <th>Estudiante</th>
                <th>Estado</th>
                <th className="text-end">Pendientes</th>
                <th className="text-end">Vencidos</th>
                <th>Riesgo</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {riesgos.length ? (
                riesgos.map((r) => (
                  <tr key={r.id}>
                    <td>{r.estudiante}</td>
                    <td>{r.estado || "-"}</td>
                    <td className="text-end">{formatNumber(r.pendientes)}</td>
                    <td className="text-end">{formatNumber(r.vencidos)}</td>
                    <td>{r.riesgo}</td>
                    <td className="text-end">
                      <button
                        className="btn btn-sm btn-outline-primary"
                        type="button"
                        title="Ver estudiante"
                        onClick={() => navigate(`/dashboard/estudiantes/${r.id}/detalle?tab=documentos`)}
                      >
                        <i className="bi bi-eye" aria-hidden="true" />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={6} className="text-center text-muted py-3">
                    Sin estudiantes en riesgo documental
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

